import React from 'react';
import styles from  './home.module.css';
import logo from '../../assets/mtc logo.png';
import { backendClient } from '../../services/MtcBackendClient';
import LoadingContext from '../../contexts/LoadingContext';
import ToastContext from '../../contexts/ToastContext';
import { parseError } from '../../utils/errorUtils';
import CustomInput, { isEmpty } from '../../components/CustomInput';
import Button from '@mui/material/Button';
import { useNavigate } from 'react-router-dom';
import { useGameSocket } from '../../providers/gameSocket.provider';


const HomeScreen: React.FC<any> = ()=>{

    // Refs
    let isRendered = React.useRef<boolean>(false);

    // Context
    const { setLoading } = React.useContext(LoadingContext)
    const { openError } = React.useContext(ToastContext);

    // Hooks
    const navigate = useNavigate();
    const { gameSocket } = useGameSocket()

    // State
    const [code, setCode] = React.useState<string>('');
    const [codeError, setCodeError] = React.useState<boolean>(false);

    // Helpers
    const validateCode = async () =>{
        try {
            setLoading(true)
            const data = await backendClient.validateCode(code);

            //openSuccess(data?.message || "");
            gameSocket?.emit("peer-connect", {
                code,
                type: 'client'
            });
            
        } catch (error) {
            setLoading(false)
            console.log(error);
            openError(parseError(error as any))
        }
    }

    // Handlers
    const handleCodeChange = (event: React.ChangeEvent<HTMLInputElement>)=>{
        if (codeError) {
            setCodeError(false);
        } 
        setCode(event.target.value);
    }
    const handleConnect: React.MouseEventHandler<HTMLButtonElement> = async (e)=>{
        if (isEmpty(code)) {
            setCodeError(true);
            return;
        }

        await validateCode()
    }

    // Effect
    React.useEffect(()=>{
        if (!isRendered.current && code) {
            gameSocket?.on('full', (isFull?: boolean)=>{
                setLoading(false);

                if (isFull) {
                    openError("The room is full! \n Another client has already connected with the host")
                }
                else {
                    console.log("App full state: ", isFull);
                    console.log("Code: ", code);
                    navigate(`/${code}`)
                }
                
            })

            isRendered.current = true;
        }
    },[code])

    // Elements
    const mtclogo = (
        <div className={styles.logo}>
            <img src={logo} alt="MTC logo" />
        </div>
    );


    return (
        <div className={styles.container}>
            { mtclogo }
            <div className={styles.prompt}>
                <p>
                    Enter a code to connect to your host
                </p>
            </div>
            <CustomInput
                className={styles.codeInput}
                error={codeError}
                errorMessage='Enter a valid code'
                maxLength={6}
                value={code}
                onChange={handleCodeChange}
            />
            <div className={styles.btnAction}>
                <Button
                    variant='contained'
                    onClick={handleConnect}
                    sx={{ color: 'white' }}
                >
                    Connect
                </Button>
            </div>
        </div>
    )
   
}

export default HomeScreen;